import { ReactNode } from "react";

export type CardCollapseProps = {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  collapseContentFixedHeight?: number;
  variant?: CardCollapseVariant;
  isLoading?: boolean;
};

export enum CardCollapseVariant {
  "success" = "success",
  "error" = "error",
}
